module.exports = __webpack_public_path__ + "assets/3ffc97437019d898f9c383bfd11e5a54.mp3";